/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Reminder_Switch_HintInputs */

const en_us2_profile_reminder_switch_hint = /** @type {(inputs: Profile_Reminder_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At the time chosen above`)
};

const pt_br2_profile_reminder_switch_hint = /** @type {(inputs: Profile_Reminder_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No horário escolhido acima`)
};

const es_419_profile_reminder_switch_hint = /** @type {(inputs: Profile_Reminder_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A la hora elegida arriba`)
};

const pt_pt2_profile_reminder_switch_hint = /** @type {(inputs: Profile_Reminder_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À hora escolhida acima`)
};

const fr_fr2_profile_reminder_switch_hint = /** @type {(inputs: Profile_Reminder_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À l'heure choisie ci-dessus`)
};

const de_de2_profile_reminder_switch_hint = /** @type {(inputs: Profile_Reminder_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zur oben gewählten Uhrzeit`)
};

const it_it2_profile_reminder_switch_hint = /** @type {(inputs: Profile_Reminder_Switch_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All'orario scelto sopra`)
};

/**
* | output |
* | --- |
* | "At the time chosen above" |
*
* @param {Profile_Reminder_Switch_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_reminder_switch_hint = /** @type {((inputs?: Profile_Reminder_Switch_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Reminder_Switch_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_reminder_switch_hint(inputs)
	if (locale === "es-419") return es_419_profile_reminder_switch_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_reminder_switch_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_reminder_switch_hint(inputs)
	if (locale === "de-DE") return de_de2_profile_reminder_switch_hint(inputs)
	if (locale === "it-IT") return it_it2_profile_reminder_switch_hint(inputs)
	return en_us2_profile_reminder_switch_hint(inputs)
});
export { profile_reminder_switch_hint as "profile.reminder_switch_hint" }